module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"message":"We can\u0027t seem to find any matching result for your search:"},"es":{"message":"Parece que no podemos encontrar ningún resultado que coincida con su búsqueda:"}}')
  delete Component.options._Ctor
}
